module.exports = __webpack_public_path__ + "img/ansi-logo-without-name.2524e461.png";